export const DynamicHeaderMenuConfig = {
   items: [
      {
         title: "Ventas",
         root: true,
         alignment: "left",
         page: "ventas",
         submenu: [
            {
               title: "Documentos Emitidos",
               svg: "./assets/deployAssets/icons/dtes3.svg",
               icon: "flaticon-business",
               page: "ventas/documentos-emitidos"
            },
            {
               title: "Factura Masiva",
               svg: "./assets/deployAssets/icons/honorarios_csv.svg",
               page: "ventas/factura-masiva",
               class: "menu-factura-masiva",
            },
            {
               title: "Guías de Despacho",
               svg: "./assets/deployAssets/icons/guias_emitidas.svg",
               page: "ventas/guias-despacho",
            },
            {
               separator: true,
            },
            {
               title: "Documentos Exportación",
               svg: "./assets/deployAssets/icons/exportacion.svg",
               page: "ventas/exportaciones",
            },
            {
               title: "Cesiones Emitidas",
               svg: "./assets/deployAssets/icons/cesiones2.svg",
               page: "ventas/cesiones",
            },
            {
               separator: true,
               class: "separator-honorarios",
            },
            {
               title: "Boletas de Honorarios",
               svg: "./assets/deployAssets/icons/honorarios.svg",
               page: "ventas/boletas-honorarios-emitidas",
               class: "menu-boletas-honorarios",
            },
            {
               title: "Boletas de Honorarios Masiva",
               svg: "./assets/deployAssets/icons/honorarios_csv.svg",
               page: "ventas/boletas-honorarios-masiva",
               class: "menu-boletas-honorarios-masiva",
            }
         ],
      },
      
      {
         title: "Compras",
         root: true,
         alignment: "left",         
         page: "compras",
         submenu: [
            {
               title: "Documentos Recibidos",
               svg: "./assets/deployAssets/icons/documentos_recibidos.svg",
               page: "compras/documentos-recibidos"
            },
            {
               title: "Facturas de Compra",
               svg: "./assets/deployAssets/icons/factura_compra.svg",
               page: "compras/facturas-compras"
            },
            {
               title: "Boletas Honorarios Recibidas",
               svg: "./assets/deployAssets/icons/honorarios.svg",
               page: "compras/boletas-honorarios-recibidas",
               class: "menu-boletas-honorarios-recibidas",
            }
         ],
      },
      {
         title: "Mantenedores",
         root: true,
         alignment: "left",
         page: "mantenedores",
         submenu: [
            {
               title: "Folios",
               bullet: true,
               page: "mantenedores/folios"
            },
            {
               title: "Usuarios",
               bullet: true,
               page: "mantenedores/usuarios"
            },
            {
               title: "Productos",
               bullet: true,
               page: "mantenedores/productos"
            },
            {
               separator: true,
            },
            {
               title: "Clientes",
               bullet: true,
               icon: "flaticon-business",
               submenu: [
                  {
                     title: "Clientes Nacionales",
                     bullet: true,
                     page: "mantenedores/clientes"
                  },
                  {
                     title: "Clientes Internacionales",
                     bullet: true,
                     page: "mantenedores/clientes-internacionales"
                  }
               ]
            },
            {
               title: "Proveedores",
               bullet: true,
               page: "mantenedores/proveedores"
            },
            {
               separator: true,
            },
            {
               title: "Cesionarios",
               bullet: true,
               page: "mantenedores/cesionarios"
            }
         ],
      },
      {
         title: "Configuración",
         page: "configuracion",
         submenu: [
            {
               title: "Perfiles",
               bullet: true,
               page: "configuracion/perfiles",
            },
            {
               title: "Empresas",
               bullet: true,
               page: "configuracion/empresas",
            },
            {
               title: "Alertas",
               bullet: true,
               page: "configuracion/alertas",
               class: "menu-alertas",
            },
            {
               title: "Certificados Digitales",
               bullet: true,
               page: "configuracion/certificados",
               class: "menu-certificados",
            },
            {
               title: "Plantillas de Impresión",
               bullet: true,
               page: "configuracion/plantillas",
               class: "menu-plantillas",
            },
         ],
      },
      {
         title: "Consolidado",
         root: true,
         alignment: "left",
         page: "consolidado/compra-venta"
      },
      {
         title: "SuperAdmin",
         page: "superadmin",
         superadmin: true,
         submenu: [
            {
               title: "Registro de Transacciones",
               bullet: true,
               page: "superadmin/logs",
            },
            {
               title: "Correos de Envío",
               bullet: true,
               page: "superadmin/correoEnvio",
            },
            {
               title: "Impuestos",
               bullet: true,
               page: "superadmin/impuestos",
            },
            {
               title: "Partners",
               bullet: true,
               page: "superadmin/resellers",
            },
         ],
      },
   ],
};
